<template>
  <div class="audit-content">
     <b-form-group label-cols-sm="3" label="Filter" class="mb-2">
        <b-input-group>
          <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
          <b-input-group-append>
            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
          </b-input-group-append>
        </b-input-group>
    </b-form-group>
    <b-table
      :items="audited"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      @filtered="onFiltered"
    ></b-table>
  </div>

</template>

<script>
import Moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  props: ['audits'],
  data() {
    return {
      sortBy: 'age',
      sortDesc: false,
      fields: [
        { key: 'timestamp', sortable: true },
        { key: 'user', sortable: true },
        { key: 'attribute', sortable: true },
        { key: 'changed_from', sortable: false },
        { key: 'changed_to', sortable: false }
      ],
      currentPage: 1,
      perPage: 10,
      filter: null
    }
  },
  computed: {
    ...mapGetters([
      'dashboard'
    ]),
    audited () {
      return this.mapAudits()
    }
  },

  methods: {
    mapAudits () {
      if (this.audits.audits) {
        let auditz = this.audits.audits.map(a =>{
          let r = {}
          r.timestamp =  this.formatDate(a.created_at)
          r.user = a.username || 'none'
          r.attribute = Object.keys(a.audited_changes)[0]
          r.changed_from = this.calcChangedFrom(a.audited_changes)
          r.changed_to = this.calcChangedTo(a.audited_changes)
          return r
        })
        return auditz
      }
    },
    calcChangedTo (a) {
      if (typeof a[Object.keys(a)[0]] === 'object') {
        return Object.values(a)[0][1]
      } else {
        return Object.values(a)[0]
      }
    },
    calcChangedFrom (a) {
      return typeof a[Object.keys(a)[0]] === 'object' ? Object.values(a)[0][0] : ''
    },
    formatDate (value) {
      if (~value.indexOf('T')) {
        return Moment(value).format('ll h:mm A')
      } else if (value) {
        return Moment(value).format('ll')
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    }
  }
}

</script>

<style>


</style>